import { openDB } from 'idb';

const DB_NAME = 'photo-gallery-db';
const FULL_STORE = 'photos';
const THUMB_STORE = 'thumbnails';
// v3: adds thumbnails store for fast gallery previews.
const DB_VERSION = 3;

export async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db, oldVersion) {
      // v2 → v3: keep full-res store, add thumbnails store.
      // v1 or fresh: wipe any old base64 store and create both.
      if (oldVersion < 2) {
        if (db.objectStoreNames.contains(FULL_STORE)) db.deleteObjectStore(FULL_STORE);
      }
      if (!db.objectStoreNames.contains(FULL_STORE)) {
        db.createObjectStore(FULL_STORE, { autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(THUMB_STORE)) {
        db.createObjectStore(THUMB_STORE);
      }
    },
  });
}

export async function savePhoto(fullBlob, thumbBlob) {
  const db = await getDB();
  const tx = db.transaction([FULL_STORE, THUMB_STORE], 'readwrite');
  const key = await tx.objectStore(FULL_STORE).add(fullBlob);
  await tx.objectStore(THUMB_STORE).add(thumbBlob, key);
  await tx.done;
  return key;
}

export async function getPhoto(key) {
  const db = await getDB();
  return db.get(FULL_STORE, key);
}

export async function getThumbnail(key) {
  const db = await getDB();
  return db.get(THUMB_STORE, key);
}

export async function getPhotos(keys) {
  const db = await getDB();
  return Promise.all(keys.map(key => db.get(FULL_STORE, key)));
}

export async function getThumbnails(keys) {
  const db = await getDB();
  return Promise.all(
    keys.map(async (key) => {
      const thumb = await db.get(THUMB_STORE, key);
      // Fall back to full-res if thumbnail is missing (e.g. photos captured before v3).
      return thumb ?? (await db.get(FULL_STORE, key));
    })
  );
}

export async function getAllPhotos() {
  const db = await getDB();
  return db.getAllKeys(FULL_STORE);
}

export async function deletePhoto(key) {
  const db = await getDB();
  const tx = db.transaction([FULL_STORE, THUMB_STORE], 'readwrite');
  await tx.objectStore(FULL_STORE).delete(key);
  await tx.objectStore(THUMB_STORE).delete(key);
  await tx.done;
}